import { render, staticRenderFns } from "./ConfigPanel.vue?vue&type=template&id=00ffd8a8&scoped=true"
import script from "./ConfigPanel.vue?vue&type=script&lang=js"
export * from "./ConfigPanel.vue?vue&type=script&lang=js"
import style0 from "./ConfigPanel.vue?vue&type=style&index=0&id=00ffd8a8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00ffd8a8",
  null
  
)

export default component.exports